module.exports = __webpack_public_path__ + "static/img/switch-favicon.23a83269.svg";